export default __webpack_public_path__ + "static/media/in_store_checkin.b4588119.svg";